import React from 'react'

import {
  bool, number, string, func, oneOfType,
} from 'prop-types'

import {
  RadioButtonsGroup,
  Card,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { formatOptions } from 'Pods/MySalesNew/formatter'

function DiscountPanel({
  participateAll,
  regularDiscount,
  superDiscount,
  onRegularDiscountChange,
  onSuperDiscountChange,
}) {
  const regularDiscountOptions = formatOptions(['30', '40', '50'])

  const superDiscountOptions = formatOptions(['50', '60', '70'])

  return (
    <div className="sales-form__settings-panel">
      <Card hasBorder isRounded>
        <p>
          Adjust the maximum discount allowed you want to offer to your
          customers:
        </p>

        <div className="sales-form__panel-container">
          <p className="text-sm">
            <strong>Regular discounts</strong> for sale offs, discounts,
            subscriptions, bulk sales and other promotions:
          </p>
          <RadioButtonsGroup
            options={regularDiscountOptions}
            name="regular-discounts"
            value={regularDiscount}
            isDisabled={!participateAll}
            onChange={onRegularDiscountChange}
            wrapperClass="custom-radio-group js-regular-discounts"
            color="custom-active-button"
          />
        </div>

        <div className="sales-form__panel-container">
          <p className="text-sm">
            <strong>Superdiscounts</strong> for sale offs, discounts,
            subscriptions, bulk sales and other promotions{' '}
            <span className="cgt-legacy-heading--disabled">
              (rare discounts on special occasions)
            </span>
          </p>
          <RadioButtonsGroup
            options={superDiscountOptions}
            name="super-discounts"
            value={superDiscount}
            isDisabled={!participateAll}
            onChange={onSuperDiscountChange}
            wrapperClass="custom-radio-group"
            color="custom-active-button"
          />
        </div>

        <div>
          <strong className="text-sm">Best price guarantee</strong>
          <p className="text-sm">
            You agree that the price of your models on CGTrader will be the
            lowest available online, with the exception of your own website. If
            a customer provides evidence before the purchase that your model is
            listed at a lower price elsewhere and requests price matching, we
            will adjust the price with a discount to fulfill that request.
          </p>
        </div>
      </Card>
    </div>
  )
}

DiscountPanel.propTypes = {
  participateAll: bool.isRequired,
  regularDiscount: oneOfType([number, string]).isRequired,
  superDiscount: oneOfType([number, string]).isRequired,
  onRegularDiscountChange: func.isRequired,
  onSuperDiscountChange: func.isRequired,
}

export default DiscountPanel
